import { Client } from '@stomp/stompjs';

 

class TaskChatService {
  constructor() {
    this.stompClient = null;
    this.subscriptions = new Map();
  }

  
  connect(onConnect, onError) {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      console.error("No token found, authentication will fail!");
      return;
    }
    const url = process.env.REACT_APP_API_URL;
    const websoketurlwithtoken= url+"/ws?token="+token;
    this.stompClient = new Client({
      // webSocketFactory: () => new SockJS(websoketurlwithtoken),
      webSocketFactory: () => new WebSocket(`wss://tasks.back.brome-consulting.com/ws?token=${token}`),
      debug: (str) => console.debug(str),
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    this.stompClient.onConnect = (frame) => { 
      // Set session attributes for tenantId and userId
      const sessionAttributes = frame.headers['session-attributes'];
      const tenantId = localStorage.getItem('tenantId');  // Assume tenantId is stored in localStorage
      const userId = localStorage.getItem('userId');      // Assume userId is stored in localStorage

      if (tenantId) {
        this.stompClient.connectHeaders = { ...this.stompClient.connectHeaders, 'tenantId': tenantId };
      }
      if (userId) {
        this.stompClient.connectHeaders = { ...this.stompClient.connectHeaders, 'userId': userId };
      }

      if (typeof onConnect === 'function') {
        onConnect(); // Ensuring the callback is a function before calling it
      }
    };

    this.stompClient.onStompError = (frame) => {
      console.error('Broker reported error:', frame.headers.message);
      if (typeof onError === 'function') {
        onError(frame.headers.message); // Ensuring the error callback is a function
      }
    };

    this.stompClient.activate();
  }

  subscribeToChat(taskId, callback) {
    const destination = `/topic/regular/tasks/${taskId}/chat`;

    if (this.subscriptions.has(destination)) {
      return; // Already subscribed
    }

    const subscription = this.stompClient.subscribe(
      destination,
      (message) => {
        const chatMessage = JSON.parse(message.body);
        callback(chatMessage);
      }
    );

    this.subscriptions.set(destination, subscription);
  }

  sendMessage(taskId, messageContent) {
    if (!this.stompClient?.connected) {
      throw new Error('Not connected to WebSocket');
    }

    const chatMessage = {
      content: messageContent,
      timestamp: new Date().toISOString()
    };

    this.stompClient.publish({
      destination: `/app/regular/tasks/${taskId}/sendMessage`,
      body: JSON.stringify(chatMessage)
    });
  }

  disconnect() {
    if (this.stompClient) {
      this.subscriptions.forEach((sub, dest) => {
        sub.unsubscribe();
        console.log('Unsubscribed from ' + dest);
      });
      this.subscriptions.clear();

      this.stompClient.deactivate();
      console.log('WebSocket disconnected');
    }
  }
}

export default new TaskChatService();
